import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import {
  NoSizesTitle,
  SizesListTitle,
  Wrapper,
  Size,
  SizesList,
} from './Sizes.styled';

const Sizes = ({ sizes }) => {
  const { t } = useTranslation();

  return (
    <Wrapper data-testid="store-card-sizes">
      {!sizes.length ? (
        <NoSizesTitle>
          {t(
            'storefinder.storeCard.productUnavailable',
            'Gewünschtes Produkt nicht verfügbar',
          )}
        </NoSizesTitle>
      ) : (
        <>
          <SizesListTitle>
            {t('storefinder.storeCard.availableSizes', 'Verfügbare Grössen:')}
          </SizesListTitle>
          <SizesList>
            {sizes.map(size => (
              <Size key={size}>{size}</Size>
            ))}
          </SizesList>
        </>
      )}
    </Wrapper>
  );
};

Sizes.propTypes = {
  sizes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Sizes;
